import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import './styles.css';

const propTypes = {
  button: PropTypes.oneOfType([PropTypes.object]).isRequired,
  changeCharClassAnim: PropTypes.func.isRequired,
  removeNonClickedButtons: PropTypes.func.isRequired,
};

const LoadCharClassButton = ({
  button,
  changeCharClassAnim,
  removeNonClickedButtons,
}) => {
  const handleButtonClick = buttonId => {
    removeNonClickedButtons(buttonId);
    changeCharClassAnim(button.type);
  };

  return (
    <div
      tabIndex={-1}
      aria-label="Class Button"
      role="button"
      className={`${isMobile ? 'mobile' : ''} class-button ${button.type}`}
      disabled={button.disabled || false}
      onClick={() => handleButtonClick(button.id)}
      onKeyPress={() => handleButtonClick(button.id)}
    />
  );
};

export default LoadCharClassButton;

LoadCharClassButton.propTypes = propTypes;
